import { useState } from 'preact/hooks';

type FAQItem = {
  question: string;
  answer: string;
};

type Props = {
  heading?: string;
  items: FAQItem[];
};

function ChevronDown() {
  return (
    <svg class="faq-item__chevron" viewBox="0 0 20 20" fill="currentColor">
      <path
        fill-rule="evenodd"
        d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
        clip-rule="evenodd"
      />
    </svg>
  );
}

export function FAQAccordion({ heading, items }: Props) {
  const [openIndex, setOpenIndex] = useState(0);

  function toggle(index: number) {
    setOpenIndex(openIndex === index ? -1 : index);
  }

  return (
    <div style="background: linear-gradient(180deg, #fff 0%, var(--m-bg-subtle) 15%); padding: 1px 0">
      <div class="faq-section">
        {heading && <h2 class="faq-section__heading">{heading}</h2>}
        {items.map((item, i) => {
          const isOpen = openIndex === i;
          return (
            <div key={i} class={`faq-item${isOpen ? ' faq-item--open' : ''}`}>
              <button
                class="faq-item__question"
                onClick={() => toggle(i)}
                aria-expanded={isOpen}
                aria-controls={`faq-answer-${i}`}
              >
                <span>{item.question}</span>
                <ChevronDown />
              </button>
              <div id={`faq-answer-${i}`} class="faq-item__answer" role="region">
                {item.answer}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
